export * from "./glyphs";

import type { ComponentType, FC, SVGProps } from "react";
import type { AgentKind } from "../kindRegistry";
import ClaudeMarkRaw from "./claude-code.svg";
import CodexMarkRaw from "./codex.svg";
import LangChainMarkRaw from "./langsmith.svg";
import OtherMarkRaw from "./other-agent.svg";

// svgr turns these .svg imports into React components, but vite types a bare
// .svg default as `string` — cast to the real component type (as the DS logos
// do) so they take className. Each renders its own tile fill.
//
// The four tiles are the Gateway-App Figma agent-type set: Claude Code
// (284:294, coral asterisk), LangChain (284:301, teal chain link), Codex
// (284:304, periwinkle prompt), Other (284:309, grey person outline).
const ClaudeMark = ClaudeMarkRaw as unknown as FC<SVGProps<SVGSVGElement>>;
const CodexMark = CodexMarkRaw as unknown as FC<SVGProps<SVGSVGElement>>;
const LangChainMark = LangChainMarkRaw as unknown as FC<
  SVGProps<SVGSVGElement>
>;
const OtherMark = OtherMarkRaw as unknown as FC<SVGProps<SVGSVGElement>>;

/* Small, colourful marks for each agent kind, used as the avatar on agent
 * cards, the overview roster and the workspace header — the Figma tile set
 * above. */

/* Exhaustive over the kind registry: adding a kind there fails this build
 * until it gets a tile. */
const MARKS: Record<AgentKind, ComponentType<{ className?: string }>> = {
  claude_code: ClaudeMark,
  langchain: LangChainMark,
  codex: CodexMark,
  // cursor: parked with its registry value (it never had a design tile).
  other: OtherMark,
};

/** Colourful logo for an agent kind (tolerates unknown/empty kinds). */
export function AgentKindLogo({
  kind,
  className = "size-6",
}: {
  kind: string;
  className?: string;
}) {
  const Mark = MARKS[kind as AgentKind] ?? OtherMark;
  return <Mark className={className} />;
}
